<template lang="pug">
  form(@submit.prevent="navigate('sistema.docModelos.new.integracao')")
    p.text-large - Informe as irregularidades do Modelo
    doc-irregularidades(v-model="$v.resource.params.osm.irregularidades.$model")
    .pt-2
      .divider
      button.btn.btn-primary(:disabled="$v.resource.$invalid")
        btn-content(name="next")
</template>

<script>
import createMixin from './mixin'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [createMixin],
  validations: {
    resource: {
      params: {
        osm: {
          irregularidades: {
            $each: {
              codigo: { required },
              descricao: { required },
            },
          },
        },
      },
    },
  },
}
</script>
